import React, { Component } from "react";
import '../Styles/Experience.css';
import Qualification from "../Components/Qualification";
import Experience from "../Components/Experience";
import ProfessionalHeader from "../Components/ProfessionalHeader";
import ScrollToTop from "../Utils/ScrollToTop";
import Certificates from "../Components/Certificates";

export default class Professional extends Component {
  render() {

    const { history } = this.props;
    
    return (
      <>
        <ScrollToTop />
        <ProfessionalHeader history={ history }/>
        <Qualification />
        <Experience />
        <Certificates />
      </>
    )
  }
}